export default __webpack_public_path__ + "static/media/Skutik-listrik-Selis.bdc78554.png";